import React, { useRef } from 'react';
import { makeStyles, Typography, useTheme } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  messageRow: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(1.5),
    width: '100%', // let the row fill the container so right-aligned bubbles sit flush to the edge
    marginRight: theme.spacing(2), // add right margin so rows don't touch the edge
  },
  bubble: {
    padding: theme.spacing(1),
    borderRadius: 12,
    boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  bubbleLeft: {
    background: '#fff',
    color: '#000',
    borderTopLeftRadius: 4,
  },
  bubbleModerator: {
    background: '#6A1B9A',
    color: '#fff',
    borderTopLeftRadius: 4,
  },
  bubbleRight: {
    background: theme.palette.primary.main,
    color: '#fff',
    borderTopRightRadius: 4,
  },
  metaTop: {
    fontSize: 12,
    marginBottom: 4,
    opacity: 0.9,
  },
  metaBottom: {
    fontSize: 11,
    opacity: 0.6,
    marginTop: 6,
    textAlign: 'right',
  },
}));

export default function CustomChatRow({ data: message, context }) {
  const classes = useStyles();
  const isMine = message.userId === context.customerId;
  const ref = useRef(null);
  const theme = useTheme();

  let bubbleClass = isMine ? `${classes.bubble} ${classes.bubbleRight}` : `${classes.bubble} ${classes.bubbleLeft}`;
  if (!isMine && message.userType === 'admin') bubbleClass = `${classes.bubble} ${classes.bubbleModerator}`;
  return (
    <div
      ref={ref}
      className={classes.messageRow}
      style={{
        alignSelf: isMine ? 'flex-end' : 'flex-start',
        textAlign: isMine ? 'right' : 'left',
        display: 'flex',
        width: '100%',
        justifyContent: isMine ? 'flex-end' : 'flex-start',
      }}
    >
      <div style={{ maxWidth: '85%', marginLeft: isMine ? 'auto' : undefined, marginRight: isMine ? theme.spacing(2) : 'auto' }}>
        <Typography className={classes.metaTop} color="textSecondary" style={{ textAlign: isMine ? 'right' : 'left' }}>
          {isMine ? 'Du' : (message.userName || message.senderName)}
        </Typography>
        <div className={bubbleClass} style={{ textAlign: isMine ? 'right' : 'left' }}>
          <Typography variant="body2">{message.message}</Typography>
          <Typography className={classes.metaBottom}>
            {message.timestamp ? new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
          </Typography>
        </div>
      </div>
    </div>
  );
}
